<app-mainscreen>
  <app-simple-page-heading [breadcrumbs]="['Dashboard > Leads']" title="Leads" ></app-simple-page-heading>
    <div class="box_container mt-4 pt-2 rounded-bottom1-0">
      <div class="box-header mb-4 w-100 pl-2">
          <label class="m-0 box_title_22 pl-1"> Leads </label>
      </div>
      <div class="row w-100">
        <div class="col-md-3 position-relative" *ngIf="userType =='2'">
          <select id="distributorId" name="distributorId" placeholder=" " class="form-control input_" [(ngModel)]="distributorId" (change)="bindResellerDDL()">
            <option *ngFor="let dis of distributorList" [value]="dis.id">
                {{dis.name}}
            </option>
            </select>
            <label for="distributorId" class="label_">Distributor</label>
        </div>
        <div class="col-md-3 position-relative" *ngIf="userType =='2' || userType =='3'">
          <select id="resellerId" name="resellerId" placeholder=" " class="form-control input_" [(ngModel)]="resellerId"  (change)="bindAgentDDL()">
            <option *ngFor="let dis of resellerList" [value]="dis.id">
                {{dis.name}}
            </option>
            </select>
            <label for="distributorId" class="label_">Reseller</label>
        </div>
        <div class="col-md-3 position-relative">
          <select id="agentId" name="agentId" placeholder=" " class="form-control input_" [(ngModel)]="agentId">
            <option *ngFor="let agt of agentList" [value]="agt.id">
                {{agt.name}}
            </option>
          </select>
          <label for="agentId" class="label_">Agent</label>
        </div>
        <div class="col-md-1">
          <app-custom-button text="Filter" [width]="'auto'" [height]="'34px'" leadingIconName="" (click)="getLeadDetails()">                    
          </app-custom-button>
      </div>
    </div>
  </div>
    <app-table-view
    [visibleColumnData] = "visibleColumnData"
    [visibleColumnsId] = "visibleColumnsId"
    [graphdata]="graphdata"
    [graphHeader]="graphHeader"
    title=""
    tableBackground="var(--grey3)"
    buttonTitle="Create Lead"
    [showIconButtonEnd]="true"
    [showPaginator]="true"  
    (onActionClick)="onActionClick($event)"
    (onCreateBtnClick)="onCreateBtnClick($event)"
    [canCreate]="canCreate"
    [canView]="canView"
    [canDelete]="canDelete"
    [canEdit]="false"
    className="rounded-top1-0"
    [showLoader]="showLoader"
  ></app-table-view>
  <app-stepper-dialog></app-stepper-dialog>
  </app-mainscreen>

  <div class="overlay" *ngIf="showViewEditModal">
        <div class="popup2 position-relative col-md-9">
            <div class="modal-header tooltip_ bg-transparent border-bottom">
            <!-- <h4 class="modal-title">Sign In</h4> -->
            <h3 class="h5">Leads Details</h3>
            <button type="button" class="close pull-right" aria-label="Close"  (click)="showViewEditModal=false;">
                <span aria-hidden="true"></span>
            </button>
            </div>
            <div class="modal-body pt-1">             
              <form [formGroup]="leadsForm">
                <div class="row">
                  <div class="col-md-3 mt-2">
                    <label class="mb-0 fw-medium">Interested In</label>
                    <input type="text" class="form-control h-34px" formControlName="interestedIn" [readOnly]="true">
                  </div>
                  <div class="col-md-3 mt-2">
                    <label class="mb-0 fw-medium">Contacted On </label>
                    <input type="datetime-local" class="form-control h-34px" formControlName="contactedOn" [readOnly]="!isEditPopup">
                  </div>
                  <div class="col-md-3 mt-2">
                    <label class="mb-0 fw-medium">Lead Status </label>
                    <fieldset [disabled]="!isEditPopup">
                      <select type="text" id="agentTitle" name="agentTitle" placeholder=" " class="form-control h-34px" formControlName="leadsStatus">
                        <option *ngFor="let level of leadsStatusList" [value]="level.value">
                            {{level.text}}
                        </option>
                      </select>
                    </fieldset>
                  </div>
                  <div class="col-md-3 mt-2">
                    <label class="mb-0 fw-medium">Policy Status </label>
                    <fieldset [disabled]="!isEditPopup">
                      <select type="text" id="agentTitle" name="agentTitle" placeholder=" " class="form-control h-34px" formControlName="policyStatus" [disabled]="!isEditPopup">
                        <option *ngFor="let level of policyStatusList" [value]="level.value">
                            {{level.text}}
                        </option>
                      </select>
                    </fieldset>
                  </div>
                  <div class="col-md-4 mt-2">
                    <label class="mb-0 fw-medium">Assigned Agent </label>
                    <app-autocomplete class="w-100" 
                      className="h-34px" 
                      [userInput]="leadsFormControl['assignedToName'].value"
                      [items]="agentAssignList" 
                      placeholder="" 
                      labelText="" 
                      (itemSelected)="onAgentSelection($event)" 
                      [supportingText]="false" 
                      [showError]="false" 
                      [isRequired]="true" 
                      [readonly]="isEditPopup ? '' : 'readOnly'"
                      [showErrorRequired]="false">
                    </app-autocomplete> 
                  </div>
                  <div class="col-md-3 mt-2 d-flex align-items-end" *ngIf="!isEditPopup && canEdit">
                    <app-custom-button text="Edit" [width]="'max-content'" className="ml-2" [height]="'36px'" leadingIconName="" (onClick)="isEditPopup = true;"></app-custom-button>
                  </div> 
                  <div class="col-md-3 mt-2 d-flex align-items-end" *ngIf="isEditPopup">
                    <app-custom-button text="Update Lead Details" [width]="'max-content'" className="ml-2" [height]="'36px'" leadingIconName="" (onClick)="updateLeadDetails()"></app-custom-button>
                  </div>                  
                  <div class="col-md-12 mt-2">
                    <label class="mb-0 fw-medium">Description</label>
                    <span class="d-block" *ngIf="description?.length == 0">{{leadsFormControl['description']?.value}}</span>
                    <div class="overflow-y-auto mx-height overflow-x-hidden p-2 border" *ngIf="description?.length > 0">
                      <div class="row">
                        <div *ngFor="let item of description" class="col-6">
                          <span class="fw-medium">{{ item.key }}</span> : {{ item.value }}
                        </div>
                      </div>
                    </div>                    
                  </div>
                </div>
              </form>
            </div>
        </div>
        </div>